import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

import { LoginService } from "../../login/login.service";
import { ClientesTestesSoproService } from "./clientes-testes-sopro.service";
import { Components } from "../../shared/components/components";
import { Global } from "../../global";
import { Funcoes } from "../../funcoes";
import { ExamesTesteSoproModel } from "../../exames/teste-sopro/exames-teste-sopro.model";

declare let $: any;

@Component({
  selector: 'app-meus-testes-sopro',
  templateUrl: './meus-testes-sopro.component.html'
})
export class MeusTestesSoproComponent extends Components implements OnInit {

  testes: ExamesTesteSoproModel[] = [];
  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "navio": "", "imo": "", "porto": "", "de": "", "ate": "" };
  listVisibilidades: any[] = [];
  clienteSelecionado: string = null;

  constructor(
    formBuilder: FormBuilder,
    private testesSoproService: ClientesTestesSoproService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    this.formPesquisaAvancada = formBuilder.group({
      navio: [],
      imo: [],
      porto: [],
      de: [],
      ate: []
    });
  }

  ngOnInit() {
    this.testesSoproService.getVisibilidades().subscribe(
      json => {
        if (json && json.Success && json.Payload) {
          this.listVisibilidades = json.Payload;
        }
      },
      error => {}
    );
    this.getPage(1);
  }

  selecionarAbaCliente(idCliente: string = null) {
    this.clienteSelecionado = idCliente;
    this.getPage(1);
  }

  formatNomeAba(nome: string): string {
    if (!nome) return '';
    return nome.length > 40 ? nome.substring(0, 40) + '...' : nome;
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.clienteSelecionado) {
      filtros['id_cliente'] = "eq:" + this.clienteSelecionado;
    }

    if (this.filtroPesquisa.navio != '') {
      filtros['navio_nome'] = "**:" + this.filtroPesquisa.navio;
    }

    if (this.filtroPesquisa.imo != '') {
      filtros['navio_imo'] = "**:" + this.filtroPesquisa.imo;
    }

    if (this.filtroPesquisa.porto != '') {
      filtros['porto_terminal'] = "**:" + this.filtroPesquisa.porto;
    }

    if (this.filtroPesquisa.de != '') {
      filtros['data_hora_inicio'] = "ge:" + this.filtroPesquisa.de + ' 00:00:00';
    }

    if (this.filtroPesquisa.ate != '') {
      filtros['data_hora_inicio'] = "le:" + this.filtroPesquisa.ate + ' 23:59:59';
    }

    this.testesSoproService.getPaginacao(pagina, this.itensPorPagina, ['cliente', 'navio', 'tripulantes.cargo', 'local', 'pdfs'], filtros)
      .subscribe(
        data => {
          this.testes = data['Payload']['data'] || [];
          this.totalItens = data['Payload']['total'] || 0;
          this.carregandoTabela = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        }
      );
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "navio": "", "imo": "", "porto": "", "de": "", "ate": "" };
  }

  visualizarPdf(teste: ExamesTesteSoproModel) {
    this.router.navigate(['/painel/area-cliente/meus-testes-sopro', teste.id, 'pdf']);
  }

  abrirPdfAnexo(teste: ExamesTesteSoproModel, pdf: any) {
    let url = this.testesSoproService.getPdfAnexoUrl(teste.id, pdf.id_pdf);
    window.open(url, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/meus-testes-sopro/meus-testes-sopro.component.ts